import { Link, useRoute } from "wouter";

const ActiveLink = ({customClass, children, handleClick, ...props}) => {
  const [isActive] = useRoute(props.href);

  return (
    <div className={`${customClass} ${isActive? "active" : ""}`} onClick={() => handleClick()}>
      <Link {...props}>
        {children}
      </Link>
    </div>
  );
};

export default ActiveLink
